import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { TableLoader } from './common/table-loader';
import { PageHeaderLoader } from './common/page-header-loader';
import { boxStyles } from '../constants/styles';

export const boxHeadingStyles = xcss({
  borderRadius: 'border.radius.200',
  borderBottomLeftRadius: '0',
  borderBottomRightRadius: '0',
});

const renderBoxHeading = () => {
  return (
    <Box xcss={boxHeadingStyles} padding="space.250" backgroundColor="color.background.neutral">
      <SkeletonLoaderWrapper testId="box-heading-loader">
        <SkeletonLoader width="24px" marginBottom="0" />
        <SkeletonLoader width="15%" marginBottom="0" />
      </SkeletonLoaderWrapper>
    </Box>
  );
};

export const renderAccordionSectionLoader = (hasRightAction?: boolean) => {
  return (
    <>
      <SkeletonLoaderWrapper>
        <SkeletonLoader width="12%" />
        {hasRightAction && <SkeletonLoader width="15%" isRightAligned />}
      </SkeletonLoaderWrapper>
      <Box xcss={boxStyles} padding="space.0">
        {renderBoxHeading()}
        <br />
        <Box paddingInline="space.250">
          <TableLoader hideActions hideFilters hideSearchBar columnsCount={7} rowsCount={3} />
        </Box>
      </Box>
    </>
  );
};

export const OrganisationDetailPageLoader = () => {
  return (
    <div>
      <PageHeaderLoader hideActions />
      <SkeletonLoaderWrapper>
        <SkeletonLoader height="24px" width="25%" marginBottom="2rem" />
      </SkeletonLoaderWrapper>
      {renderAccordionSectionLoader()}
      <br />
      {renderAccordionSectionLoader(true)}
      <br />
    </div>
  );
};
